import { createTheme } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const {
  CUSTOMBLACK_LIGHT_CONTRASTTEXT,
  CUSTOMBLACK_LIGHT_DARK,
  CUSTOMBLACK_LIGHT_LIGHT,
  CUSTOMBLACK_LIGHT_MAIN,
  CUSTOMGREY_LIGHT_CONTRASTTEXT,
  CUSTOMGREY_LIGHT_LIGHT,
  CUSTOMGREY_LIGHT_MAIN,
  DARK_TOAST_TEXT,
  DARK_TEXT,
  ERROR_TEXT,
  DEFAULT_SWITCH_THUMB,
  DEFAULT_SWITCH_TRACK,
  GRAY_SCROLLBAR_BACKROUND,
  LIGHT_FIELDS_ON_CARD_MENU,
  LIGHT_PAPER,
  LIGHT_TEXT,
  LIGHT_TOAST_BACKGROUND,
  LIGHT_TOOLTIP_BACKGROUND,
  MAINMENU_BACKGROUND_COLOR_LIGHT,
  ON_SWITCH_THUMB,
  PLAIN_TEXTBOX_INPUT,
  PRIMARY_ACTION_LIGHT,
  PRIMARY_LIGHT,
  PRIMARY_SLIDER_TRACK,
  PRIMARY_TOAST_BORDER,
  PRIMARY_TOOLTIP_BORDER,
  SECONDARY_LIGHT,
  TRANSPARENT_AUTOFILL,
} = COLORS;

export const lightTheme = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: PRIMARY_LIGHT,
    },
    secondary: {
      main: SECONDARY_LIGHT,
    },
    action: {
      hover: PRIMARY_ACTION_LIGHT,
    },
    customGrey: {
      light: CUSTOMGREY_LIGHT_LIGHT,
      main: CUSTOMGREY_LIGHT_MAIN,
      dark: CUSTOMGREY_LIGHT_MAIN,
      contrastText: CUSTOMGREY_LIGHT_CONTRASTTEXT,
    },
    customBlack: {
      dark: CUSTOMBLACK_LIGHT_DARK,
      main: CUSTOMBLACK_LIGHT_MAIN,
      light: CUSTOMBLACK_LIGHT_LIGHT,
      contrastText: CUSTOMBLACK_LIGHT_CONTRASTTEXT,
    },
    error: {
      main: ERROR_TEXT,
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },
  overrides: {
    MuiButton: {
      root: {
        textTransform: 'none',
        fontSize: 13,
      },
    },
    MuiDialogContent: {
      // root: {
      //   overflow: 'hidden !important',
      // },
    },
    MuiListItem: {
      root: {
        //add hover effect
        '&:hover': {
          backgroundColor: `${MAINMENU_BACKGROUND_COLOR_LIGHT} !important`,
        },
      },
    },
    MuiTooltip: {
      tooltip: {
        backgroundColor: LIGHT_TOOLTIP_BACKGROUND,
        color: DARK_TEXT,
        border: `1px solid ${PRIMARY_TOOLTIP_BORDER}`,
        whiteSpace: 'pre-wrap',
      },
    },

    MuiInputLabel: {
      root: {
        color: `${DARK_TEXT} !important`,
      },
    },
    MuiSwitch: {
      switchBase: {
        // Controls default (unchecked) color for the thumb
        color: DEFAULT_SWITCH_THUMB + '!important',
      },
      colorSecondary: {
        '&$checked': {
          // Controls checked color for the thumb
          color: ON_SWITCH_THUMB,
        },
      },
      track: {
        // Controls default (unchecked) color for the track
        opacity: 0.2,
        backgroundColor: DEFAULT_SWITCH_TRACK,
        '$checked$checked + &': {
          // Controls checked color for the track
          opacity: 0.7,
          backgroundColor: `${PRIMARY_SLIDER_TRACK} !important`,
        },
      },
    },
    MuiInputBase: {
      root: {
        backgroundColor: `${PLAIN_TEXTBOX_INPUT} !important`,
      },
      input: {
        '&::placeholder': {
          color: `${LIGHT_TEXT} !important`,
          fontWeight: 500,
          fontSize: '12px !important',
          opacity: '0.8 !important',
        },
      },
    },
    MuiMenuItem: {
      root: {
        '&:hover': {
          backgroundColor: LIGHT_FIELDS_ON_CARD_MENU + '!important',
        },
      },
    },
    MuiOutlinedInput: {
      input: {
        '&:-webkit-autofill': {
          // Transparent but chrome don't allow transparent autofill
          WebkitBoxShadow: '0 0 0 100px transparent inset',
          // Transition delays the chrome coloring the auto fill
          transition: TRANSPARENT_AUTOFILL,
        },
      },
    },
    MuiPaper: {
      root: {
        '& .MuiAutocomplete-option': {
          '&:hover': {
            backgroundColor: LIGHT_PAPER,
          },
          '&[data-focus="true"]': {
            backgroundColor: LIGHT_PAPER,
          },
        },
      },
    },
    MuiSnackbarContent: {
      root: {
        backgroundColor: LIGHT_TOAST_BACKGROUND,
        color: DARK_TOAST_TEXT,
        boxShadow: 'none',
        border: `1px solid ${PRIMARY_TOAST_BORDER}`,
      },
    },
    MuiCssBaseline: {
      '@global': {
        '*': {
          '&::-webkit-scrollbar-track': {
            backgroundColor: GRAY_SCROLLBAR_BACKROUND,
          },
        },
      },
    },
  },
});
